import { Box, Grid, IconButton, Tooltip, Typography } from '@mui/material';
import { useEffect, useState } from 'react'
import CustomSearch from '../../../Components/CustomSearch/CustomSearch';
import CustomDropDown from '../../../Components/CustomDropDown/CustomDropDown';
import TableContainer from '../../../Components/TableContainer/TableContainer';
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import LaunchIcon from '@mui/icons-material/Launch';
import AxiosInstance from '../../../Config/AxiosInstance';
import APILIST from '../../../Config/ApiList';
import useDebounce from '../../../Components/useDebounce/useDebounce';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
const SessionManagement = () => {
    const pageSize = 15;
    const navigate = useNavigate();
    const [isStatus, setIsStatus] = useState(null);
    const [sessionList, setSessionList] = useState([]);
    const [searchUser, setSearchUser] = useState("");
    const [page, setPage] = useState(0);
    const [count, setCount] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const debouncedSearch = useDebounce(searchUser, 500);
    const isStatusList = [
        { name: "All", id: null },
        { id: 1, name: "Inroute", label: "Inroute" },
        { id: 2, name: "Arrived", label: "Arrived" },
        { id: 3, name: "Start", label: "Start" },
        { id: 4, name: "Pause", label: "Pause" },
        { id: 5, name: "Resume", label: "Resume" },
        { id: 6, name: "Completed", label: "Completed" },
        { id: 7, name: "Incomplete", label: "Incomplete" },
        { id: 8, name: "Checked", label: "Checked" },
    ];
    const columns = [
        {
            field: "action",
            headerName: "Actions",
            minWidth: 100,
            filterable: false,
            editable: false,
            sortable: false,
            disableColumnMenu: true,
            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "10px",
                        }}
                    >
                        <Tooltip title="View" key="view">
                            <IconButton
                                onClick={() => {
                                    navigate("/admin/session-details-details", {
                                        state: {
                                            userSessionID: params?.row?.id,
                                        }
                                    })
                                }}
                                sx={{
                                    width: "30px",
                                    height: "30px",
                                    borderRadius: "4px",
                                    background:
                                        "linear-gradient(148.97deg, #0C2C50 0%, #450F5B 100%)",
                                    "&:hover": {
                                        background:
                                            "linear-gradient(148.97deg, #0C2C50 0%, #450F5B 100%)",
                                    },
                                }}
                            >
                                <RemoveRedEyeIcon sx={{ color: "#fff" }} />
                            </IconButton>
                        </Tooltip>
                    </Box>
                );
            },
        },
        {
            field: "rowid",
            headerName: "Sr.No.",
            minWidth: 100,
            filterable: false,
            editable: false,
            sortable: false,
            disableColumnMenu: true,
        },
        {
            field: "title",
            headerName: "Title",
            minWidth: 250,
            filterable: true,
            sortable: true,
            renderCell: (params) => {
                const Title = params?.row?.title || "--";
                return (
                    <Tooltip title={Title?.length > 25 ? Title : ""}>
                        <span>
                            {Title?.length > 25
                                ? `${Title?.substring(0, 25)}...`
                                : Title}
                        </span>
                    </Tooltip>
                );
            },
        },
        {
            field: "user_name",
            headerName: "Client Name",

            minWidth: 250,
            filterable: true,
            sortable: true,
            renderCell: (params) => {
                const userDetails = params?.row?.user_details?.full_name || "--";
                return (
                    <Tooltip title={userDetails?.length > 25 ? userDetails : ""}>
                        <span style={{
                            display:'flex',
                            alignItems:'center',
                            gap:'10px'
                        }} onClick={() => {
                            navigate(`/admin/user-details`, {
                                state: { id: params?.row?.user_details?.id },
                            });
                        }}>
                            {userDetails?.length > 25
                                ? `${userDetails?.substring(0, 25)}...`
                                : userDetails}
                            <LaunchIcon />
                        </span>
                    </Tooltip>
                );
            },
        },
        {
            field: "interpreter_name",
            headerName: "Interpreter Name",
            minWidth: 250,
            filterable: true,
            sortable: true,
            renderCell: (params) => {
                const clientDetails = params?.row?.interpreter_details?.full_name || "--";
                return (
                    <Tooltip title={clientDetails?.length > 25 ? clientDetails : ""}>
                        <span style={{
                            display:'flex',
                            alignItems:'center',
                            gap:'10px'
                        }} onClick={() => {
                            navigate(`/admin/interpreter-details`, {
                                state: { id: params?.row?.interpreter_details?.id },
                            });
                        }}>
                            {clientDetails?.length > 25
                                ? `${clientDetails?.substring(0, 25)}...`
                                : clientDetails}
                            <LaunchIcon />
                        </span>
                    </Tooltip>
                );
            },
        },
        {
            field: "service_type",
            headerName: "Service Type",
            flex: 1,
            minWidth: 150,
            hideOnMobile: true,
            renderCell: (params) => {
                const jobType = params?.row?.service_type ? params?.row?.service_type === 1
                    ? "Onsite"
                    : params?.row?.service_type === 2
                        ? "Virtual"
                        : "Both" : "N/A";
                return (
                    <Typography sx={{
                        background: "rgba(0, 151, 178, 0.2)",
                        padding: '4px 10px',
                        borderRadius: '22px',
                        fontSize: '12px',
                        fontWeight: '500',
                        fontFamily: "Outfit",
                        width: 'fit-content',
                        color: 'rgba(2, 56, 85, 1)'
                    }}>
                        {jobType?.length > 25
                            ? `${jobType?.substring(0, 25)}...`
                            : jobType}
                    </Typography>
                )
            }
        },
        {
            field: "location",
            headerName: "Location",
            minWidth: 300,
            filterable: false,
            editable: false,
            sortable: false,
            hideOnMobile: true,
            disableColumnMenu: true,
            renderCell: (params) => (
                <Tooltip title={params?.row?.location?.length > 25 ? params?.row?.location : ""}>
                    <span>
                        {params?.row?.location?.length > 25
                            ? `${params?.row?.location?.substring(0, 25)}...`
                            : params?.row?.location}
                    </span>
                </Tooltip>
            ),
        },
        {
            field: "date",
            headerName: "Date & Time",
            minWidth: 160,
            filterable: false,
            editable: false,
            sortable: false,
            hideOnMobile: true,
            disableColumnMenu: true,
            renderCell: (params) => (
                <span>
                    {moment(params?.row?.date_time).local().format('DD MMM YYYY hh:mm A')}
                </span>
            ),
        },
        {
            field: "language",
            headerName: "Language",
            minWidth: 300,
            filterable: false,
            editable: false,
            sortable: false,
            hideOnMobile: true,
            disableColumnMenu: true,
            renderCell: (params) => (
                <span>
                    {params?.row?.from_language || "N/A"} → {params?.row?.to_language || "N/A"}
                </span>
            ),
        },
        {
            field: "estimated_hours",
            headerName: "Total Hours",
            minWidth: 100,
            filterable: false,
            editable: false,
            sortable: false,
            hideOnMobile: true,
            disableColumnMenu: true,
            renderCell: (params) => (
                <span>
                    {params?.row?.estimated_hours || "N/A"}
                </span>
            ),
        },
        {
            field: "payment_status",
            headerName: "Payment Status",
            minWidth: 200,
            filterable: false,
            editable: false,
            sortable: false,
            hideOnMobile: true,
            disableColumnMenu: true,
            renderCell: (params) => (
                <span>
                    {params?.row?.payment_status || "N/A"}
                </span>
            ),
        },
    ];

    const handlePageChange = (newPage) => {
        setPage(newPage);
    };
    useEffect(() => {
        getAllSessionList();
    }, [debouncedSearch, page, isStatus]);
    const getAllSessionList = async () => {
        try {
            setIsLoading(true)
            const response = await AxiosInstance.get(APILIST.GET_ALL_ADMIN_SESSIONS, {
                params: {
                    skip: page * pageSize,
                    limit: pageSize,
                    ...(debouncedSearch && { search: debouncedSearch }),
                    ...(isStatus && { tracking_status: isStatus }),
                }
            })
            if (response && response?.data?.s === 1) {
                const Rowdata = response?.data?.r?.map((data, i) => ({
                    rowid: i + 1 + page * pageSize,
                    ...data,
                }));
                setIsLoading(false)
                setSessionList(Rowdata);
                page === 0 && setCount(response?.data?.total || 0);
            } else {
                setSessionList([]);
                setIsLoading(false)
            }
        } catch (error) {
            setIsLoading(false)
            setSessionList([]);
            console.log('Error', error);

        }
    }

    return (
        <Box
            sx={{
                width: "100%",
                bgcolor: "#fff",
                padding: '10px'
            }}
        >
            <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                    <Typography sx={{ fontSize: "24px", fontWeight: "500", fontFamily: 'Outfit', }}>
                        Session Management
                    </Typography>
                </Grid>
                <Grid item xs={12} md={3}>
                    <CustomSearch
                        placeholder="Search"
                        value={searchUser}
                        onChange={(event) => setSearchUser(event.target.value)}
                        onClear={() => setSearchUser("")}
                    />
                </Grid>
                <Grid item xs={12} md={3}>
                    <CustomDropDown
                        sx={{ height: "46px" }}
                        placeholder={"Select Status"}
                        menuList={isStatusList}
                        value={isStatus}
                        onChange={(e) =>
                            setIsStatus(e.target.value)
                        }
                        getLabel={(item) => item?.name}
                    />
                </Grid>
            </Grid>
            <Box
                sx={{
                    width: "100%",
                    paddingTop: "24px",
                }}
            >
                <TableContainer
                    rows={sessionList}
                    columns={columns}
                    pageSize={pageSize}
                    loading={isLoading}
                    page={page}
                    totalCount={count}
                    handlePageChange={handlePageChange}
                    isPagination={true}
                    sx={{
                        height: "calc(100vh - 150px)"
                    }}
                />
            </Box>
        </Box>
    )
}

export default SessionManagement